"use strict";
/*
 * Created on 01 25 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ReleaseType_1 = require("../../release/model/ReleaseType");

var ReleaseWorkflowType_1 = require("../../release/model/ReleaseWorkflowType");

var Role_1 = require("../../user/model/Role");

var SelloutDescription_1 = require("../model/SelloutDescription");

var SelloutDescriptionConverter_1 = require("./SelloutDescriptionConverter");
/**
 * @author Jaroslav Sevcik
 */


var SelloutDescriptionConverterImpl =
/*#__PURE__*/
function (_SelloutDescriptionCo) {
  _inherits(SelloutDescriptionConverterImpl, _SelloutDescriptionCo);

  function SelloutDescriptionConverterImpl() {
    _classCallCheck(this, SelloutDescriptionConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(SelloutDescriptionConverterImpl).apply(this, arguments));
  }

  _createClass(SelloutDescriptionConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new SelloutDescription_1.SelloutDescription(SelloutDescription_1.SelloutDescription.schema.basic.valueOf(source.basic), SelloutDescription_1.SelloutDescription.schema.identification.valueOf(source.identification), SelloutDescription_1.SelloutDescription.schema.priceCalculation.valueOf(source.priceCalculation), SelloutDescription_1.SelloutDescription.schema.responsibilities.valueOf(conversions.asObjectList(source, 'responsibilities', function (doc) {
        return new Role_1.Role(doc.name);
      })), SelloutDescription_1.SelloutDescription.schema.releaseTypes.valueOf(conversions.asObjectList(source, 'releaseTypes', function (releaseType) {
        return conversions.asEnum(releaseType, ReleaseType_1.ReleaseType);
      })), SelloutDescription_1.SelloutDescription.schema.workflowTypes.valueOf(conversions.asObjectList(source, 'workflowTypes', function (workflowType) {
        return conversions.asEnum(workflowType, ReleaseWorkflowType_1.ReleaseWorkflowType);
      })), SelloutDescription_1.SelloutDescription.schema.targetCondition.valueOf(source.targetCondition), SelloutDescription_1.SelloutDescription.schema.endingOfValidity.valueOf(source.endingOfValidity), SelloutDescription_1.SelloutDescription.schema.notification.valueOf(source.notification));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      return {
        basic: source.basic,
        identification: source.identification,
        priceCalculation: source.priceCalculation,
        responsibilities: conversions.asObjectArray(source, 'responsibilities', function (role) {
          return {
            name: role.name
          };
        }),
        releaseTypes: conversions.asObjectArray(source, 'releaseTypes', function (releaseType) {
          return releaseType;
        }),
        workflowTypes: conversions.asObjectArray(source, 'workflowTypes', function (workflowType) {
          return workflowType;
        }),
        targetCondition: source.targetCondition,
        endingOfValidity: source.endingOfValidity,
        notification: source.notification
      };
    }
  }]);

  return SelloutDescriptionConverterImpl;
}(SelloutDescriptionConverter_1.SelloutDescriptionConverter);

exports.SelloutDescriptionConverterImpl = SelloutDescriptionConverterImpl;